import React from "react";
import "./newservices.css";
import whatsnew from "../../images/services/selfdriving.png";

export default function Newservices() {
  return (
    <div className="servicess">
      <div className="headingyanew">
        <div className="juuyacontaineryanew">What's new</div>
      </div>
      <div className="subservices">
        <div className="serviceswraper8">
          <div className="static">
            <img src={whatsnew} alt="" className="imageyenyewe" />
            <div className="chiniyakeimage">
              <h3>
                Our AI (Artificial Intelligence) Stranger Recognition System
              </h3>
              <li>Get notified when a stranger gets into the car</li>
              <li>
                Get the time he or she entered the car, how long he or she
                stayed, and the time he or she got out
              </li>
              <li>Record the conversation they had</li>
            </div>
          </div>
          <div className="dynamic dynamic3">
            <div className="lefttwo">
              <h3>Our Car Tracking System Entails</h3>

              <li>Car Tracking</li>
              <li>Remote fuel monitoring</li>
              <li>Stranger in car alerts</li>
              <li>Geofence setup and alerts</li>
              <li>Remote Engine Stopping</li>
              <li>Overspeeding alerts</li>
              <li>Car at home alerts</li>
              <li>Overtaking alerts</li>
            </div>
            <div className="righttwo">
              <h3>We Provide you with Analysed data of</h3>
              <li>Monthly fuel consumption</li>
              <li>Location history</li>
              <li>Monthly driving hours</li>
              <li>Number of passangers carried in a month</li>
              <li>Average monthly driving speed</li>
              <li>More</li>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
